import { isEqual } from 'lodash';
import { apiGet, hasPermission } from './apiWrapper';
import { searchSubjectsSucceeded, searchSubjectsFailed } from './searchStore'
import { unicornCountry } from './marketingListStore'
import { repiDomain } from './repiStore';

const initiateType = "INITIATE_DOMAIN_REQUEST";
const failType = "RECEIVE_DOMAIN_REQUEST_FAIL";
const successType = "RECEIVE_DOMAIN_REQUEST_SUCCESS";
const syncRuntimeDomainsType = "SYNC_RUNTIME_DOMAINS";
const resetDomainData = "RESET_DOMAIN_DATA";
const changeMarketingDomainsCountry = "CHANGE_MARKETING_DOMAINS_COUNTRY";
const changeMarketingConfigDomainsCountry = "CHANGE_MARKETING_CONFIG_DOMAINS_COUNTRY";
export const marketingDomainsLoaded = "MARKETING_DOMAINS_LOADED";
export const marketingConfigDomainsLoaded = "MARKETING_CONFIG_DOMAINS_LOADED";
export const financialDomainsLoaded = "FINANCIAL_DOMAINS_LOADED";
export const portfolioDomainsLoaded = "PORTFOLIO_DOMAINS_LOADED";

export const propertySkDomainKeys = {
    districts: 'cadastre-districts',
    municipalities: 'cadastre-municipalities',
    cadastreUnits: 'cadastre-units',
    cadastreLandTypes: 'cadastre-land-types',
    cadastreOwnershipTypes: 'cadastre-ownership-types'
};

export const propertyCzDomainKeys = {
    municipalities: 'cadastre-cz-municipalities',
    cadastreUnits: 'cadastre-cz-units'
};

const domainInitialState = { isRequesting: false, requestResult: null };
const initialState = {
    countries: { ...domainInitialState },
    'nace': { ...domainInitialState },
    divisions: { ...domainInitialState },
    'summary-overviews': { ...domainInitialState },
    'ratiobookyears': { ...domainInitialState },
    'warning-types': { ...domainInitialState },
    'additional-info': { ...domainInitialState },
    'institutional-sectors': { ...domainInitialState },
    'ownership-types': { ...domainInitialState },
    'legal-form-types': { ...domainInitialState },
    sources: { ...domainInitialState },
    'turnover-ranges': { ...domainInitialState },
    'turnover-years': { ...domainInitialState },
    'size-categories': { ...domainInitialState },
    'countries-tree': { ...domainInitialState },
    relations: { ...domainInitialState },
    'fin-statement-values': { ...domainInitialState },
    'fin-statement-values-ifrs': { ...domainInitialState },
    'fin-statement-values-ifrs-original': { ...domainInitialState },
    'fin-statement-values-organizations-values-sasp': { ...domainInitialState },
    'fin-statement-values-organizations-values-v': { ...domainInitialState },
    'fin-statement-values-organizations-values-vh': { ...domainInitialState },
    'fin-statement-values-organizations-values-vp': { ...domainInitialState },
    'fin-statement-values-organizations-values-all': { ...domainInitialState },
    'fin-statement-values-organizations-types': { ...domainInitialState },
    'fin-statement-ratios': { ...domainInitialState },
    'region-district-city': { ...domainInitialState },
    'city': { ...domainInitialState },
    'cities': { ...domainInitialState },
    'districts': { ...domainInitialState },
    'regions': { ...domainInitialState },
    'bankruptcy-type-codes': { ...domainInitialState },
    'bulletin-record-types': { ...domainInitialState },
    'monitored-list-types': { ...domainInitialState },
    'monitored-events-dictionary': { ...domainInitialState },
    'relation-group-dictionary': { ...domainInitialState },
    'fin-statement-types': { ...domainInitialState },
    'fin-statement-types-ifrs': { ...domainInitialState },
    'fin-statement-types-ifrs-consolidated': { ...domainInitialState },
    'fin-statement-types-ifrs-individual': { ...domainInitialState },
    'fin-statement-types-ifrs-orig': { ...domainInitialState },
    'report-types': { ...domainInitialState },
    'vehicle-categories': { ...domainInitialState },
    [repiDomain.currencies]: { ...domainInitialState },
    [repiDomain.countries]: { ...domainInitialState },
    [repiDomain.addresses]: { ...domainInitialState },
    [repiDomain.contacts]: { ...domainInitialState },
    [repiDomain.documents]: { ...domainInitialState },
    [repiDomain.dunningLevels]: { ...domainInitialState },
    [repiDomain.products]: { ...domainInitialState },
    [propertySkDomainKeys.districts]: { ...domainInitialState },
    [propertySkDomainKeys.municipalities]: { ...domainInitialState },
    [propertySkDomainKeys.cadastreUnits]: { ...domainInitialState },
    [propertySkDomainKeys.cadastreLandTypes]: { ...domainInitialState },
    [propertySkDomainKeys.cadastreOwnershipTypes]: { ...domainInitialState },
    [propertyCzDomainKeys.municipalities]: { ...domainInitialState },
    [propertyCzDomainKeys.cadastreUnits]: { ...domainInitialState },
    'coi-rel-types': { ...domainInitialState },
    marketingDomainsLoaded: false,
    marketingConfigDomainsLoaded: false,
    financialDomainsLoaded: false,
    portfolioDomainsLoaded: false,
    marketingDomainsCountry: null,
    marketingConfigDomainsCountry: null
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case initiateType:
            return updateSearchState(state, action.domain, { isRequesting: true, requestResult: null });
        case failType:
            return updateSearchState(state, action.domain, { isRequesting: false, requestResult: false });
        case successType:
            return updateSearchState(state, action.domain, { isRequesting: false, requestResult: action.domainData, params: action.params });
        case syncRuntimeDomainsType:
            return { ...state, runtime: action.data };
        case '@@localize/SET_ACTIVE_LANGUAGE':
            return initialState;
        case searchSubjectsSucceeded:
        case searchSubjectsFailed:
            return { ...state, runtime: undefined };
        case resetDomainData:
            return updateSearchState(state, action.domain, { isRequesting: false, requestResult: null })
        /*SPECIFIC CASE WHERE WE NEED TO WAIT FOR DOMAIN VALUES TO LOAD AND DISPLAY CONTENT ONLY AFTER LOADED */
        case marketingDomainsLoaded:
            return { ...state, marketingDomainsLoaded: true };
        case marketingConfigDomainsLoaded:
            return { ...state, marketingConfigDomainsLoaded: true };
        case financialDomainsLoaded:
            return { ...state, financialDomainsLoaded: true };
        case portfolioDomainsLoaded:
            return { ...state, portfolioDomainsLoaded: true };
        case changeMarketingDomainsCountry:
            return { ...state, marketingDomainsCountry: action.country, marketingDomainsLoaded: false };
        case changeMarketingConfigDomainsCountry:
            return { ...state, marketingConfigDomainsCountry: action.country, marketingConfigDomainsLoaded: false };
        default:
            return state;
    }
}

function updateSearchState(state, domain, update) {
    return state[domain] ? { ...state, [domain]: { ...state[domain], ...update } } : state;
}

function getUrl(domain) { return window.babylonApiUrl + `/api/domain/${domain}`; }

function ensureDomainData(domain, byMarketAttribute, params, forced, dispatch, getState) {
    const domainData = getState().domain[domain];
    if (byMarketAttribute === true)
        params = { ...params, marketAttribute: getMarketAttribute(getState) };
    if (!domainData || (forced || domainData.requestResult === null || !isEqual(domainData.params, params)) && domainData.isRequesting === false) {
        dispatch({ type: initiateType, domain: domain });
        apiGet(getUrl(domain), params,
            response => {
                if (getState().domain[domain].isRequesting === false) {
                    // this is a edge case - this should only occur when either language or user profile is changed (@@localize/SET_ACTIVE_LANGUAGE,
                    // userProfileRequest, userProfile actions) while request for data is still running - maybe will never happen.
                    // Now trigger fetching again for data in just selected language/profile
                    ensureDomainData(domain, byMarketAttribute, params, dispatch, getState);

                } else {
                    dispatch({ type: successType, domain: domain, domainData: response.data, params });
                    marketingDomainLoading(dispatch, getState);
                    marketingConfigDomainLoading(dispatch, getState);
                    financialDomainLoading(dispatch, getState);
                    portfolioDomainLoading(dispatch, getState);
                }
            },
            () => dispatch({ type: failType, domain: domain })
        );
    }
}

export const domainActions = {
    ensureDomainData: (domain, filter) => async (dispatch, getState) => ensureDomainData(domain, false, filter, false, dispatch, getState),
    ensureDomainDataByMarketAttribute: (domain, filter) => async (dispatch, getState) => ensureDomainData(domain, true, filter, false, dispatch, getState),
    forceDomainDataFiltered: (domain, filter) => async (dispatch, getState) => ensureDomainData(domain, false, filter, true, dispatch, getState),
    attachRuntimeDomainData: (domains) => async (dispatch, getState) => syncDomains(domains, dispatch, getState),
    resetDomainData: (domain) => async (dispatch) => { dispatch({ type: resetDomainData, domain: domain }) },
    setDomain: (domain, data) => (dispatch) => { dispatch({ type: successType, domain: domain, domainData: data }) },
    setMarketingDomainsCountry: (country) => (dispatch) => { dispatch({ type: changeMarketingDomainsCountry, country }) },
    setMarketingConfigDomainsCountry: (country) => (dispatch) => { dispatch({ type: changeMarketingConfigDomainsCountry, country }) }
};

const syncDomains = (domains, dispatch, getState) => {
    dispatch({ type: syncRuntimeDomainsType, data: domains });
}

const marketingDomainLoading = (dispatch, getState) => {
    if (getState().domain['nace'].requestResult !== null
        && getState().domain['size-categories'].requestResult !== null
        && getState().domain['institutional-sectors'].requestResult !== null
        && getState().domain['ownership-types'].requestResult !== null
        && getState().domain['turnover-ranges'].requestResult !== null
        && getState().domain['turnover-years'].requestResult !== null
        && getState().domain['countries-tree'].requestResult !== null
        && getState().domain['additional-info'].requestResult !== null
        && getState().domain['warning-types'].requestResult !== null
        && getState().domain['legal-form-types'].requestResult !== null
        && getState().domain['fin-statement-values'].requestResult !== null
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-ifrs'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-ifrs-original'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-sasp'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-v'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-vh'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-vp'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-all'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-types'].requestResult !== null)

        && getState().domain['fin-statement-ratios'].requestResult !== null
        && getState().domain['regions'].requestResult !== null
        && getState().domain['districts'].requestResult !== null
        && getState().domain['cities'].requestResult !== null
        && getState().domain.sources.requestResult !== null
    ) {
        dispatch({ type: marketingDomainsLoaded })
    };
}

const marketingConfigDomainLoading = (dispatch, getState) => {
    if (getState().domain['relations'].requestResult !== null
        && getState().domain['additional-info'].requestResult !== null
        && getState().domain['warning-types'].requestResult !== null
        && getState().domain.sources.requestResult !== null
        && getState().domain['fin-statement-ratios'].requestResult !== null
        && getState().domain['fin-statement-types'].requestResult !== null
        && ((unicornCountry() === 'cz' && getState().domain['vehicle-categories'].requestResult !== null)
            || (unicornCountry() === 'sk'
                && getState().domain['fin-statement-types-ifrs-consolidated'].requestResult !== null
                && getState().domain['fin-statement-types-ifrs-individual'].requestResult !== null
                && getState().domain['fin-statement-types-ifrs-orig'].requestResult !== null))
    ) {
        dispatch({ type: marketingConfigDomainsLoaded })
    };
}

const financialDomainLoading = (dispatch, getState) => {
    if (getState().domain['fin-statement-values'].requestResult !== null
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-ifrs'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-ifrs-original'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-sasp'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-v'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-vh'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-vp'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-values-all'].requestResult !== null)
        && (unicornCountry() !== 'sk' || getState().domain['fin-statement-values-organizations-types'].requestResult !== null)
        && getState().domain['fin-statement-ratios'].requestResult !== null) {
        dispatch({ type: financialDomainsLoaded })
    };
}

const portfolioDomainLoading = (dispatch, getState) => {
    if (getState().domain['monitored-list-types'].requestResult !== null
        && getState().domain['sources'].requestResult !== null
        && getState().domain['monitored-events-dictionary'].requestResult !== null
    ) {
        dispatch({ type: portfolioDomainsLoaded })
    };
}
const getMarketAttribute = (getState) => {
    var hasCzechDataPermission = hasPermission(getState().userContext, 'AccessCzechData');
    var hasSlovakDataPermission = hasPermission(getState().userContext, 'AccessSlovakData');

    if (hasCzechDataPermission && !hasSlovakDataPermission) {
        return 1;
    } else if (!hasCzechDataPermission && hasSlovakDataPermission) {
        return 2;
    } else {
        return 3;
    }
}
